(function(){
  console.log();

  
  
})();


/* Notes
hook onto
	data-option-index= var 
    	var = 0 for colors 
        var = 1 for size
        
   iterrate through data-values for data-option-indes="1"
   disable if not available 



*/